export interface CannedResponse {
  /**
   * The button text should be of the form "Contact Skyhook.." or "Trip forms can.."
   * to imply the underlying text message
   */
  buttonText: string;
  message: string;
}

const cannedResponses: CannedResponse[] = [
  {
    buttonText: 'Pay balance..',
    message: `You can pay the balance by heading over to your dashboard at https://www.skyhookadventure.com/me and then clicking on your booking. Then under the "Invoice" section it should have an option called "Pay balance". I hope that helps!`,
  },
  {
    buttonText: 'Cancel..',
    message: `Sorry to hear you can't travel any more. You can cancel your booking by heading over to your dashboard at https://www.skyhookadventure.com/me and then clicking on your booking. Then under the "Invoice" section you can click "Cancel / change dates" and it will show you what you'll get. If you're happy, just click confirm and it will do that all automatically for you. If you need something bespoke however the best thing to do is contact Skyhook tech support at https://www.skyhookadventure.com/help/contact .`,
  },
  {
    buttonText: 'Change dates..',
    message: `You can change your dates by heading over to your dashboard at https://www.skyhookadventure.com/me and then clicking on your booking. Then under the "Invoice" section you can click "Cancel / change dates" and it will talk you through how to do this. If you're happy, just click confirm and it will do that all automatically for you. If you need something bespoke however the best thing to do is contact Skyhook tech support at https://www.skyhookadventure.com/help/contact .`,
  },
  {
    buttonText: 'Complete form..',
    message: `You can complete your form by heading over to your dashboard at https://www.skyhookadventure.com/me and then clicking on your booking. Then under the "Your team" section it has some buttons to complete your trip form, or send it to a friend to fill in. I hope that helps!`,
  },
  {
    buttonText: 'Contact Skyhook..',
    message: `It sounds like this would be best solved by Skyhook tech/billing support. Are you able to drop them a message at https://www.skyhookadventure.com/help/contact ?`,
  },
  {
    buttonText: 'Visa Letter',
    message: `You can get these from your dashboard at https://www.skyhookadventure.com/me by going to the Invoice section and then clicking on "Visa Letter". Please note only the person who made the booking can download these, so if you are a guest on their booking you will need to ask them to do this for you.`,
  },
];

export default cannedResponses;
